
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
    name: 'Information',

    components: {
        Swiper,
        SwiperSlide,
    },

    props: {
        info: {
            type: Object,
            default: () => '',
        },
    },

    data() {
        return {
            swiperOptions: {
                spaceBetween: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,

                loop: true,

                navigation: {
                    prevEl: '.progress-information__button-navition--prev',
                    nextEl: '.progress-information__button-navition--next',
                },
            },

            activeImage: 1,
        };
    },

    computed: {
        message() {
            return [this.info.month_name, this.info.stage_name]
                .filter((t) => !!t).join(' - ');
        },
        images() {
            return this.info?.images || [];
        },
    },

    methods: {
        changeSlide(event) {
            const newIndex = this.$refs.refSwiper?.$swiper?.activeIndex;
            this.activeImage = newIndex + 1;
        },
        openPopUpImages() {
            const images = this.images.map((t) => t.image_id);
            this.$store.commit('pop-up-images/setImages', {
                images,
                parametrs: {
                    activeIndex: this.activeImage - 1,
                },
            });
        },
    },
};
